import { makeStyles } from "@material-ui/core/styles";

const usePortfolioListItemStyles = makeStyles((theme) => ({
  refunded_btn: {
    "&.Mui-disabled": {
      backgroundColor: "#3eb8aa",
      opacity: 0.5,
      color: "#fff",
    },
  },
}));

export default usePortfolioListItemStyles;
